const LOG_IN = 'tuko-kalenteri/login/LOG_IN';
const LOG_OUT = 'tuko-kalenteri/login/LOG_OUT';
const SET_ADMIN = 'tuko-kalenteri/login/SET_ADMIN';

export default function login(state = { loggedIn: false, user: undefined, isAdmin: false }, action) {
  switch (action.type) {
    case LOG_IN:
      return Object.assign({}, state, { loggedIn: true, user: action.user });
    case LOG_OUT:
      return Object.assign({}, state, { loggedIn: false, user: undefined });
    case SET_ADMIN:
      return Object.assign({}, state, { isAdmin: action.isAdmin });
    default:
      return state;
  }
}

export function logIn(user) {
  return { type: LOG_IN, user };
}

export function logOut() {
  return { type: LOG_OUT };
}

export function setAdmin(isAdmin) {
  return { type: SET_ADMIN, isAdmin };
}



// WEBPACK FOOTER //
// ./src/reducers/login.js